import { useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import type { ApprovalCopy } from '@/frontend/features/Fde/WorkApprovals/types'

export default function FeedbackForm({ projectId, proposalId, copy }: { projectId: string; proposalId?: string; copy: ApprovalCopy }) {
  const form = useForm({ kind: 'preference', topic: '', body: '', work_proposal_id: proposalId ?? '' })
  return <details className="border-t py-4">
    <summary className="cursor-pointer text-xs text-muted-foreground transition-colors hover:text-foreground">{copy.ui.add_guidance}</summary>
    <form className="mt-4 space-y-4" onSubmit={e => {
    e.preventDefault()
    form.post(`/dashboard/discovery/project_feedbacks?project_id=${projectId}`, { preserveScroll: true, onSuccess: () => form.reset('body') })
  }}>
    <div><h2 className="font-medium">{copy.feedback_title}</h2><p className="mt-1 text-sm text-muted-foreground">{copy.feedback_hint}</p></div>
    <label className="block space-y-2" htmlFor="feedback-kind"><span className="text-sm">{copy.kind}</span>
      <select id="feedback-kind" className="w-full rounded-md border bg-background p-2 text-sm" value={form.data.kind} onChange={e => form.setData('kind', e.target.value)}>
        {(['preference', 'useful', 'avoid'] as const).map(kind => <option key={kind} value={kind}>{copy[kind]}</option>)}
      </select>
    </label>
    <label className="block space-y-2" htmlFor="feedback-topic"><span className="text-sm">{copy.topic}</span>
      <Input id="feedback-topic" required value={form.data.topic} onChange={e => form.setData('topic', e.target.value)} />
    </label>
    <label className="block space-y-2" htmlFor="feedback-body"><span className="text-sm">{copy.body}</span>
      <Textarea id="feedback-body" required value={form.data.body} onChange={e => form.setData('body', e.target.value)} />
    </label>
    {Object.values(form.errors).map(error => <p key={error} className="text-sm text-destructive" role="alert">{error}</p>)}
    <Button variant="outline" disabled={form.processing}>{copy.save_feedback}</Button>
    </form>
  </details>
}
